export default __webpack_public_path__ + "media/images/logo-bf941a4708dbe3040edfa058a523a21e.svg";